'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userFollows;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function buildFeedUserIdKeyFromAction(action) {
  var _action$payload = action.payload,
      feedUserType = _action$payload.feedUserType,
      feedUserRelatedId = _action$payload.feedUserRelatedId;

  return feedUserType + '-' + feedUserRelatedId;
}

function userFollows() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var feedUserIdKey = void 0;

  switch (action.type) {
    case _actionTypes.REQUEST_FOLLOW_USER:
    case _actionTypes.FAIL_UNFOLLOW_USER:
      feedUserIdKey = buildFeedUserIdKeyFromAction(action);
      return Object.assign({}, state, _defineProperty({}, feedUserIdKey, true));
    case _actionTypes.REQUEST_UNFOLLOW_USER:
    case _actionTypes.FAIL_FOLLOW_USER:
      feedUserIdKey = buildFeedUserIdKeyFromAction(action);
      return Object.assign({}, state, _defineProperty({}, feedUserIdKey, false));
    case _actionTypes.SET_USER_FOLLOW:
      feedUserIdKey = buildFeedUserIdKeyFromAction(action);
      var isFollowing = action.payload.isFollowing;

      return Object.assign({}, state, _defineProperty({}, feedUserIdKey, isFollowing));
    default:
      return state;
  }
}